import React, { useState, useEffect, useContext } from "react";
import "./../../Configuracion/configuracion.css";
import { validate } from "react-email-validator";
import StoreContext from "../Store/Context";
import { DATATABLE_CLIENTES } from "../Datatables";
import { STATES_CLI_CLIENTES } from "../States";
import { FIND_DESC } from "../Util";
import { CLOSE_IMAGE } from "../Image";
import { NavLink as RRNavLink } from "react-router-dom";
import { ClienteModal, DeleteModal } from "../Modal";
import { get_re_retencion, get_cli_cliente, post_cli_cliente, put_cli_cliente, put_cli_cliente_sts, consultar_ruc } from "../Services";
import { Container, NavLink } from "reactstrap";
import { MDBIcon, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";

export const Contactos = () => {
  const [iconsActive, setIconsActive] = useState("tab1");
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };

  return (
    <div className="cfg-admin font-s12px">
      <header className="cfg-header">
        <div className="cfg-header-info">
          <h1 className="cfg-title">Clientes</h1>
          <p className="cfg-subtitle">Administración de clientes</p>
        </div>
        <MDBTabs className="cfg-tabs">
          <MDBTabsItem>
            <MDBTabsLink onClick={() => handleIconsClick("tab1")} active={iconsActive === "tab1"}>
              <MDBIcon fas icon="users" className="me-2" /> Clientes
            </MDBTabsLink>
          </MDBTabsItem>
        </MDBTabs>
        <NavLink tag={RRNavLink} to="/user/home" className="cfg-close" title="Cerrar">
          <img src={CLOSE_IMAGE} alt="Cerrar" />
        </NavLink>
      </header>
      <MDBTabsContent className="cfg-content">
        <MDBTabsPane show={iconsActive === "tab1"} className="overflow-c">
          <Clientes
            setError={setError}
            error={error}
            setBasicModal={setBasicModal}
            basicModal={basicModal}
            basicModalDelete={basicModalDelete}
            setBasicModalDelete={setBasicModalDelete}
            basicModalEdit={basicModalEdit}
            setBasicModalEdit={setBasicModalEdit}
            isLoading={isLoading}
            setLoading={setLoading}
          />
        </MDBTabsPane>
      </MDBTabsContent>
    </div>
  );
};

function Clientes({ setError, error, basicModal, setBasicModal, setBasicModalDelete, basicModalDelete, basicModalEdit, setBasicModalEdit, isLoading, setLoading }) {
  const { usr_sucursal } = useContext(StoreContext);
  const [dataRetencion, setDataRetencion] = useState([]);
  const [dataClientes, setDataClientes] = useState([]);
  const [formClientes, setFormClientes] = useState(STATES_CLI_CLIENTES("formClientes"));
  const setFormClientesBlank = () => {
    setFormClientes(STATES_CLI_CLIENTES("formClientes"));
  };

  const onClickUpdateClient = () => {
    setLoading(true);
    var body = {
      cli_id: formClientes.cli_id,
      cli_nombre: formClientes.cli_nombre,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_ruc: formClientes.cli_ruc.trim().toUpperCase(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_credito: formClientes.cli_credito,
      cli_retencion: formClientes.re_id,
      cli_exento: formClientes.cli_exento,
      cli_tipo_clienteFE: formClientes.cli_tipo_clienteFE,
      cli_tipoContribuyente: formClientes.cli_tipoContribuyente,
    };
    if (formClientes.cli_nombre.length > 0) {
      if (formClientes.cli_email.length > 0) {
        if (validate(formClientes.cli_email)) {
          if (FIND_DESC(dataClientes, formClientes.cli_ruc, formClientes.cli_id)) {
            setError("Error: Ruc ya esta registrado");
          } else {
            var result = put_cli_cliente(body);
            result.then((data) => {
              setError("");
              if (data === true) {
                setLoading(false);
                fetchCliente();
              } else setError("ERROR " + data);
            });
          }
        } else {
          setError("E-Mail incorrecto");
        }
      } else {
        if (FIND_DESC(dataClientes, formClientes.cli_ruc, formClientes.cli_id)) {
          setError("Error: Ruc ya esta registrado");
        } else {
          var result = put_cli_cliente(body);
          result.then((data) => {
            setError("");
            if (data === true) fetchCliente();
            else setError("ERROR " + data);
          });
        }
      }
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  const onClickUpdateCliente_sts = () => {
    var body = {
      cli_id: formClientes.cli_id,
      cli_sts: 0,
    };
    var result = put_cli_cliente_sts(body);
    result.then((data) => {
      setError("");
      if (data === true) fetchCliente();
      else setError("ERROR " + data);
    });
  };

  const onClickSaveCliente = () => {
    var body = {
      cli_nombre: formClientes.cli_nombre,
      cli_suc: usr_sucursal,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_ruc: formClientes.cli_ruc.trim().toUpperCase(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_credito: formClientes.cli_credito,
      cli_retencion: formClientes.re_id,
      cli_exento: formClientes.cli_exento,
      cli_tipo_clienteFE: formClientes.cli_tipo_clienteFE,
      cli_tipoContribuyente: formClientes.cli_tipoContribuyente,
      return: true,
    };

    if (formClientes.cli_nombre.length > 0) {
      if (FIND_DESC(dataClientes, formClientes.cli_ruc, null)) {
        setError("Error: Ruc ya esta registrado");
      } else {
        var result = post_cli_cliente(body);
        result.then((data) => {
          setError("");
          if (data === true) fetchCliente();
          else setError("ERROR " + data);
        });
      }
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchCliente() {
    setLoading(true);
    var response;
    response = await get_cli_cliente(usr_sucursal);
    setDataClientes(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name, type, checked } = event.target;
    let newForm = {
      ...formClientes,
      [name]: type === "checkbox" ? (checked ? "1" : "0") : value,
    };

    if (name === "cli_tipo_clienteFE") {
      // CONSUMIDOR FINAL -> NATURAL
      if (value === "02") {
        newForm.cli_tipoContribuyente = "1";
      }

      if (value === "04") {
        newForm.cli_tipoContribuyente = "";
      }
    }

    if (name === "cli_tipoContribuyente") {
      if (formClientes.cli_tipo_clienteFE === "02") {
        newForm.cli_tipoContribuyente = "1";
      }

      if (formClientes.cli_tipo_clienteFE === "04") {
        newForm.cli_tipoContribuyente = "";
      }
    }

    setFormClientes(newForm);
    setError("");
  }

  async function fetchReRetencion() {
    var response = await get_re_retencion();
    setDataRetencion(response);
  }

  useEffect(() => {
    fetchCliente();
    fetchReRetencion();
  }, []);

  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setFormClientes({
      ...formClientes,
      [name]: value === "0" ? "1" : "0",
    });
  };
  async function onClickBuscarRuc({ ruc, is_modal_ruc }) {
    if (ruc.length > 0) {
      var result = await consultar_ruc({ ruc });
      if (result.ConsultarRucDVResult.codigo === "200") {
        setFormClientes({
          ...formClientes,
          cli_nombre: result.ConsultarRucDVResult.infoRuc.razonSocial,
          cli_tipoContribuyente: result.ConsultarRucDVResult.infoRuc.tipoRuc,
          cli_tipo_clienteFE: "01",
          cli_ruc: result.ConsultarRucDVResult.infoRuc.ruc,
          cli_dv: result.ConsultarRucDVResult.infoRuc.dv,
        });
      } else {
        setFormClientes({ ...formClientes, cli_tipoContribuyente: "1", cli_tipo_clienteFE: "02", cli_nombre: "", cli_ruc: result?.ConsultarRucDVResult?.infoRuc?.ruc ?? "", cli_dv: result?.ConsultarRucDVResult?.infoRuc?.dv ?? "" });
        setError("RUC: " + ruc + " No se encontro resultados");
      }
    }
  }

  return (
    <Container fluid className="cfg-panel font-s12px contenedor-tabla">
      {basicModal && (
        <ClienteModal
          props={formClientes}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveCliente}
          toggleSaveEdit={onClickUpdateClient}
          onChange={onChange}
          error={error}
          setFormClientesBlank={setFormClientesBlank}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          setFormClientes={setFormClientes}
          onClickBuscarRuc={onClickBuscarRuc}
          dataRetencion={dataRetencion}
          loading={isLoading}
        />
      )}
      {basicModalDelete && <DeleteModal props={formClientes.cli_nombre + " " + formClientes.cli_ruc + " " + formClientes.cli_dv} isOpen={basicModalDelete} toggle={setBasicModalDelete} toggleDelete={onClickUpdateCliente_sts} text={"Eliminar este registro?"} error={error} />}

      <div className="cfg-card modal-add-inventario datatable-factura css_datatable1 tabla-auto-height">
        <DATATABLE_CLIENTES
          dataClientes={dataClientes}
          setBasicModalDelete={setBasicModalDelete}
          setFormClientes={setFormClientes}
          setBasicModal={setBasicModal}
          setBasicModalEdit={setBasicModalEdit}
          setError={setError}
          fetchCliente={fetchCliente}
          isLoadingC={isLoading}
          dataRetencion={dataRetencion}
        />
      </div>
    </Container>
  );
}
